import { useApi } from './use-api-call';
import { ProductDTO } from './product-api';
import { api } from './api';

export const useSearchLicenseApi = () =>
    useApi<{
        licenses: LicenseDTO[];
        products: ProductDTO[];
        allowEdit: boolean;
    }>('/license/search-license');

export const useFilterLicensesApi = () =>
    useApi<{
        licenses: LicenseDTO[];
        totalCount: number;
        pageSize: number;
        pageIndex: number;
    }>('/license/filter-licenses');

export const useGetLicenseApi = () =>
    useApi<{ license: LicenseDTO; allowEdit: boolean }>('/license/get-license/{serial}');

export const useSaveLicenseApi = () => useApi<{ license: LicenseDTO }>('/license/save-license');

export const useDeleteLicenseApi = () => useApi('/license/delete-license/{serial}');
export const useUpdateLicenseKeyApi = () => useApi<{ license: LicenseDTO }>('/license/update-license-key');
export const downloadSampleExcelApi = () => api.download(`/license/download-license-sample`);
export const downloadAvailableLicensesApi = () =>
    api.download(`/license/download-available-licenses`);
export const makePreviewLicensesFromExcelApi = (file: File) =>
    api.upload('/license/make-preview-licenses-from-excel', file);
export const importLicensesApi = (licenses: LicensePreviewDTO[]) =>
    api.post('/license/import-licences', { licenses });
export interface LicenseDTO {
    serial?: number;
    productId: number;
    licenseKey: string;
    licenseCode?: string;
    batchNumber?: string;
    isDelivered: boolean;
    deliveredAt?: Date;
    deliveredToUserName?: string;
    deliveredToCodeId?: number;
    hasOpenTicket?: boolean;
    ticketStatus?: string;
}
export interface LicensePreviewDTO {
    licenseKey: string;
    productId: number;
    productName: string;
    exists: boolean;
}
